import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedDate } from "react-intl";
import { Modal } from "react-bootstrap";

import AlmigButton from "../grundelemente/AlmigButton";
import AlmigDropDown, {genAlmigDropdownItems, genAlmigDropdownTitle } from "../grundelemente/AlmigDropDown";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoEmpty from "../grundelemente/InfoEmpty";
import InfoPanel from "../grundelemente/InfoPanel";
import Zeitraum from "../grundelemente/Zeitraum";
import {
	CHARTS_DATA_SOURCE_LIVE_STANDARD,
	chartsDataSourceIndex
} from "../model/Diagramme"

const DailyValuesDatum = props => (
	props.timespan.request_pending
		? <span>---</span>
		: <FormattedDate value={props.timespan[props.date_field]} />
);

DailyValuesDatum.propTypes = {
	timespan: PropTypes.object.isRequired,
	date_field: PropTypes.string.isRequired
};

class DailyValuesInfoPanel extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			show_time_dialog: false,
			new_range: null
		};
	}
	getDateOfElementOfSortedListOfHeDataLogFiles(listElement) {
		let aDate = new Date();
		aDate.setFullYear(listElement.year);
		aDate.setMonth(listElement.month - 1);
		aDate.setDate(listElement.day);
		aDate.setHours(12);
		aDate.setMinutes(0);
		aDate.setSeconds(0);
		aDate.setMilliseconds(0);
		return aDate;
	}
	getMaxDateHeDataLogs() {
		if(
			(this.props.sortedListOfHeDataLogFiles == null) ||
			(this.props.sortedListOfHeDataLogFiles.length === 0)
		) {
			return undefined;
		}
		const lastIndex = this.props.sortedListOfHeDataLogFiles.length - 1;
		const lastElement = this.props.sortedListOfHeDataLogFiles[lastIndex];
		return this.getDateOfElementOfSortedListOfHeDataLogFiles(lastElement);
	}
	getMinDateHeDataLogs() {
		if(
			(this.props.sortedListOfHeDataLogFiles == null) ||
			(this.props.sortedListOfHeDataLogFiles.length === 0)
		) {
			return undefined;
		}
		const firstElement = this.props.sortedListOfHeDataLogFiles[0];
		return this.getDateOfElementOfSortedListOfHeDataLogFiles(firstElement);
	}
	getMaxDate() {
		if(this.props.dataSourceOfCharts === CHARTS_DATA_SOURCE_LIVE_STANDARD)		 {
			return this.props.today;
		}
		else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
			return this.getMaxDateHeDataLogs();
		}
	}
	getMinDate() {
		if(this.props.dataSourceOfCharts === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
			return new Date(0);
		}
		else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
			return this.getMinDateHeDataLogs();
		}
	}
	handleRangeChange(range) {
		this.setState({ new_range: range });
	}
	handleOk() {
		if (this.state.new_range) {
			if(this.props.dataSourceOfCharts === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
				this.props.setTimespan(this.state.new_range);
			}
			else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
				this.props.setTimespanHeDataLogFiles(this.state.new_range, this.props.sortedListOfHeDataLogFiles);
			}
		}
		this.setState({
			show_time_dialog: false,
			new_range: null
		});
	}
	render() {
		let { timespan } = this.props;
		return (
			<React.Fragment>
				<InfoPanel>
					<InfoBlock>
						<AlmigButton i18n_key="Print preview"
							onClick={() => this.props.printRequest()}/>
					</InfoBlock>
					<InfoBlock>
						<AlmigButton i18n_key="Change dates" onClick={() =>
							this.setState({show_time_dialog: true})} />
					</InfoBlock>
					<InfoEmpty height="200px" />
					<InfoBlock>
						<FormattedMessage id="From" /><br />
						<DailyValuesDatum timespan={timespan} date_field="from_ms" /><br />
						<FormattedMessage id="Until" /><br />
						<DailyValuesDatum timespan={timespan} date_field="until_ms" />
					</InfoBlock>
					<InfoDateContainer />
				</InfoPanel>
				<Modal show={this.state.show_time_dialog}
					aria-labelledby="contained-modal-title">
					<Modal.Header>
						<FormattedMessage id="Data Source"/><br/>
						<AlmigDropDown
							id="chartsDataSourceIndex"
							title={genAlmigDropdownTitle(chartsDataSourceIndex, this.props.dataSourceOfCharts)}
						>
							{ genAlmigDropdownItems(chartsDataSourceIndex, this.props.setDataSourceOfCharts) }
						</AlmigDropDown>
					</Modal.Header>
					<Modal.Body>
						<Zeitraum
							range={timespan}
							max_date={this.getMaxDate()}
							min_date={this.getMinDate()}
							onRangeChanged={range => this.handleRangeChange(range)}
						/>
					</Modal.Body>
					<Modal.Footer>
						<AlmigButton i18n_key="Apply" onClick={() => this.handleOk()} />
					</Modal.Footer>
				</Modal>
			</React.Fragment>
		);
	}
}

DailyValuesInfoPanel.propTypes = {
	timespan: PropTypes.object.isRequired,
	today: PropTypes.instanceOf(Date),
	dataSourceOfCharts: PropTypes.number.isRequired,
	sortedListOfHeDataLogFiles: PropTypes.array.isRequired,
	setTimespan: PropTypes.func.isRequired,
	setTimespanHeDataLogFiles: PropTypes.func.isRequired,
	printRequest: PropTypes.func.isRequired,
	setDataSourceOfCharts: PropTypes.func.isRequired
};

export default DailyValuesInfoPanel;
